import { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { update_current_album_and_song } from "../../actions/currentalbum";
import { set_song } from "../../actions/song";
import { setIsPlaying } from "../../actions/isplaying";

import "./searchfield.css";

const SearchField = () =>
{

  const dispatch = useDispatch();
  let [matches, setMatches] = useState([]);
  let [currentAlbumIndex, setCurrentAlbumIndex] = useState(-1);
  let albums = useSelector((state) => state.albums)
  let scuf = [];

  // Reference to input field
  const searchInputRef = useRef();

  const handleUpdate = (evt) =>
  {
    /// Like with most of this codebase, this code is bad
    /// I do not enjoy working in javascript and so i will not be fixing it

    scuf = [];
    setCurrentAlbumIndex(0);
    if (!evt.target.value.length) return setMatches(scuf);

    for (let i = 0; i < albums.length; i++)
    {
      /* if ((albums[i].album.substr(0, evt.target.value.length).toLowerCase()) === evt.target.value.toLowerCase())
      {
        scuf.push(albums[i]);
      } */
      if (albums[i].album.toLowerCase().includes(evt.target.value.toLowerCase()))
      {
        scuf.push(albums[i]);
      }
    }
    setMatches(scuf);

  }

  const handleKeyDown = (evt) =>
  {
    switch (evt.key)
    {
      case "ArrowUp":
        evt.preventDefault();
        currentAlbumIndex === 0 ? setCurrentAlbumIndex(matches.length - 1) : setCurrentAlbumIndex(currentAlbumIndex -= 1);
        break;
      case "ArrowDown":
        evt.preventDefault();
        currentAlbumIndex === matches.length - 1 ? setCurrentAlbumIndex(0) : setCurrentAlbumIndex(currentAlbumIndex += 1);
        break;
      case "Enter":
        if (!matches[currentAlbumIndex]) return;
        handleClick(evt, matches[currentAlbumIndex])
        break;
      default:
        return;
    }
  }

  const handleSubmit = (evt) =>
  {
    /**
     * Just clearing it, why it's a form I have no idea
     */
    evt.preventDefault();
    // Remove focus from input field
    searchInputRef.current.blur();
    scuf = [];
    setMatches(scuf);
    evt.target[0].value = "";
  }


  const handleClick = (evt, match) =>
  {

    /**
     * Lmao
     */

    dispatch(update_current_album_and_song(albums, match.index, 0));
    dispatch(set_song(match.songs[0]));
    dispatch(setIsPlaying(true));
    scuf = [];
    setMatches(scuf);
    evt.target.parentElement.parentElement.firstChild.value = "";
  }







  // This is so scuffed
  // If searching, focus search field
  window.addEventListener("keydown", (evt) =>
  {
    if (evt.ctrlKey && evt.key === "f")
    {
      evt.preventDefault();
      searchInputRef.current.focus();
    }
  });



  return (
    <>
      <form onSubmit={(evt) => handleSubmit(evt)} style={{ display: "inline" }}>
        <input ref={searchInputRef} onChange={(evt) => handleUpdate(evt)} onKeyDown={(evt) => handleKeyDown(evt)} style={{ background: "black", margin: "2px", color: "white" }} />
        <div className="searchContainer">
          {matches.map((match, i) => (
            <div onClick={(evt) => handleClick(evt, match)}
              className={i !== currentAlbumIndex ? "searchSuggestions" : "selectedSuggestion"}
              key={i}>{match.album}</div>
          ))}
        </div>
      </form>
    </>
  );
}

export default SearchField;
